import {
  AssetMimeTypes,
  PublicResource,
  ResourceBase
} from '@cube3/state/types';
import { getNodeDisplayImageSrc } from '@cube3/ui/src/human/nodeDisplayImageResolver';

import assetImage from '@cube3/ui/src/assets/images/Library/file.svg?url';
import folderImage from '@cube3/ui/src/assets/images/Library/folder.svg?url';
import audioFileImage from '@cube3/ui/src/assets/images/Library/audio.svg?url';
import {
  ActivityAction,
  ASSET_ACTIONS,
  FOLDER_ACTIONS
} from '@cube3/common/model/types/activity-types';
import { ActivityImageType } from '@cube3/cubicle/src/core/molecules/Activity/ActivityItem';
import { getData } from './getRelationshipData';

interface Config {
  resource: ResourceBase & { mime_type: AssetMimeTypes };
  context: PublicResource;
  action: string;
}

enum ExportTargetNames {
  broadcast = 'broadcast',
  youtube = 'youtube',
  meta = 'meta',
  contentful = 'contentful',
  cm360 = 'cm360',
  tiktok = 'tiktok',
  googleads = 'googleads',
  radio = 'radio'
}

const toName = (name = '') => {
  for (const verb in ExportTargetNames) {
    if (name.toLowerCase().includes(verb.toLowerCase())) {
      return verb;
    }
  }
};

export const getActivityImageType = (
  action: ActivityAction,
  context
): ActivityImageType => {
  const assetRelated = Object.hasOwn(
    { ...ASSET_ACTIONS, ...FOLDER_ACTIONS },
    action
  );

  const accountRelated = action.toLowerCase().includes('account');

  if (accountRelated || context === 'share') {
    return 'avatar';
  }
  if (context === 'asset') {
    const exportRelated = action.toLowerCase().includes('export');
    const downloadRelated = action.toLowerCase().includes('downloaded');
    return exportRelated ? 'brand' : downloadRelated ? 'icon' : 'avatar';
  }

  return assetRelated ? 'thumbnail' : 'icon';
};

export const getExportTargetIcon = (name: string) => {
  switch (toName(name)) {
    case 'youtube':
      return 'google_YouTube_Brand';
    case 'meta':
      return 'meta_Brand';
    case 'cm360':
      return 'google_CM360_Brand';
    case 'contentful':
      return 'contentful_Brand';
    case 'tiktok':
      return 'tiktok_Brand';
    case 'googleads':
      return 'google_Ads_Brand';
    case 'broadcast':
      return 'broadcast';
    case 'radio':
      return 'radio';
    default:
      return 'export';
  }
};

export const getActivityImage = ({ action, resource, context }: Config) => {
  if (resource?.trashed_at) {
    switch (resource.mime_type) {
      case 'application/vnd.cube.folder':
        return folderImage;
      case 'application/vnd.cube.audio':
        return audioFileImage;
      default:
        return assetImage;
    }
  }
  if (action.toLowerCase().includes('export')) {
    const brandName =
      context?.display_name || getData(context, 'export-target-type')?.id;

    const logo = getExportTargetIcon(brandName);
    return logo;
  }

  if (context?.display_image) {
    return context.display_image;
  }

  if (action.toLowerCase().includes('project')) {
    return 'project';
  }

  if (action.toLowerCase().includes('share')) {
    return 'link';
  }
  if (action.toLowerCase().includes('contract')) {
    return 'contract';
  }

  if (action.toLowerCase().includes('downloaded')) {
    return 'download';
  }

  return getNodeDisplayImageSrc(resource);
};
